import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAdminAuth } from '@/context/AdminAuthContext';

/**
 * AdminProtectedRoute — wrappa le route admin.
 * - undefined → mostra spinner mentre verifica
 * - null      → redirect a /admin/login
 * - oggetto   → render children
 */
export default function AdminProtectedRoute({ children }) {
  const { user } = useAdminAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen bg-ivory flex items-center justify-center" data-testid="admin-loading">
        <Loader2 className="w-8 h-8 text-bordeaux animate-spin" />
      </div>
    );
  }

  if (user === null) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
